import { Alert, Grid, Group, Paper, Space, Title } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { useState } from 'react';
import { AlertCircle, X } from 'tabler-icons-react';
import { BusinessFileNamesReadable } from '../../../../enums/business-file-names';
import StepperButton from '../../../buttons/stepper.button/stepper.button';
import RepresentativeEscalationInformation from '../business-form-components/representative-information.component';
import SettlementDetails from '../business-form-components/settlement-details.component';
import UploadDocuments from '../business-form-components/upload-documents.component';

function CorporationForm(props: {
  form: any;
  mainForm: any;
  active: number;
  nextStep: () => void;
  prevStep: () => void;
}) {
  const { form, mainForm, active, nextStep, prevStep } = props;
  const [loading, setLoading] = useState(false);

  const handlePrevStep = () => {
    setLoading(true);
    mainForm.setValues(form.values);
    form.clearErrors();
    setLoading(false);
    if (!loading) prevStep();
  };

  const handleSubmit = () => {
    const {
      idsOfValidSignatories,
      mayorsOrBusinessPermit,
      birCert2303,
      secCert,
      aoiAndByLaws,
      gis,
      secretarysCert,
    } = form.values;

    let errMsg = '';

    const noPermits =
      mayorsOrBusinessPermit.length === 0 &&
      birCert2303.length === 0 &&
      secCert.length === 0;

    const noOwnership = aoiAndByLaws.length === 0 && gis.length === 0;

    if (idsOfValidSignatories.length === 0) {
      errMsg = `Please upload ${BusinessFileNamesReadable.VALID_IDS_OF_SIGNATORY}`;
    } else if (noPermits) {
      errMsg = `Please upload any of the three: ${BusinessFileNamesReadable.MAYORS_OR_BUSINESS_PERMIT},
      ${BusinessFileNamesReadable.BIR_CERTIFICATE_2303},  ${BusinessFileNamesReadable.SEC_CERTIFICATE}`;
    } else if (noOwnership) {
      errMsg = `Please upload any of the two:  ${BusinessFileNamesReadable.AOI_AND_BY_LAWS} 
      and ${BusinessFileNamesReadable.GIS}`;
    } else if (secretarysCert.length === 0) {
      errMsg = `Please upload  ${BusinessFileNamesReadable.SECRETARYS_CERTIFICATE}`;
    }

    if (errMsg !== '') {
      showNotification({
        id: 'failed-to-move-next-step',
        message: errMsg,
        icon: <X size={16} />,
        color: 'red',
        autoClose: 10000,
      });
      return;
    }

    setLoading(true);
    mainForm.setValues(form.values);
    setLoading(false);
    if (!loading) nextStep();
  };
  return (
    <>
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Grid mb={15}>
          <Grid.Col>
            <Title order={1}>Business Information</Title>
          </Grid.Col>
          <Grid.Col>
            <Title order={2} style={{ fontWeight: 500 }}>
              Corporation
            </Title>
          </Grid.Col>
        </Grid>
        <Paper className='general-info-step' p={25} shadow='md' withBorder>
          <Grid>
            <Grid.Col>
              <RepresentativeEscalationInformation form={form} />
            </Grid.Col>
            <Grid.Col>
              <SettlementDetails form={form} />
            </Grid.Col>
            <Grid.Col>
              <UploadDocuments
                form={form}
                businessTypeId={form.values.businessTypeId}
              />
            </Grid.Col>
          </Grid>
        </Paper>
        <Group
          style={{ width: '100%' }}
          grow
          position='apart'
          align='flex-start'
          mt={30}
        >
          {Object.keys(form.errors).length > 0 ? (
            <Alert
              icon={<AlertCircle size={16} />}
              title='Invalid fields'
              color='red'
              variant='outline'
            >
              Please check fields for errors
            </Alert>
          ) : (
            <Space />
          )}
          <StepperButton
            prevStep={handlePrevStep}
            active={active}
            submit
            nextStep={undefined}
            loading={loading}
          />
        </Group>
      </form>
    </>
  );
}

export default CorporationForm;
